var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.toggleState.apply(null, arguments)}}},[_c('i',{staticClass:"fa",class:_vm.activated ? 'fa-bookmark' : 'fa-bookmark-o'})])
}
var staticRenderFns = []

export { render, staticRenderFns }